import gql from 'graphql-tag'

export const GET_PERSON_USER = gql`
  query GetPersonUser($person_id: ID!) {
    person(id: $person_id) {
      id
      user {
        id
        email
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Profile/tabs/graphql.js